import { inject, injectable } from 'tsyringe';

import { AuthenticationServiceTokens as Tokens } from '../di-tokens';
import type { Credentials } from '../domain';
import type { JWT, JWTAuthenticationService, VueRouterRedirectionService } from '../services';
import { SessionContainer } from '../session/session-container';

/**
 * User wants to sign in into the application.
 */
@injectable()
export class LoginUseCase {
    public constructor(
        @inject(Tokens.AuthenticationService)
        private authService: JWTAuthenticationService,

        @inject(Tokens.SessionContainer)
        private sessionContainer: SessionContainer<JWT>,

        @inject(Tokens.RedirectService)
        private redirectService: VueRouterRedirectionService
    ) {}

    public async execute(credentials: Credentials) {
        const authData = await this.authService.logIn(credentials.accountId, credentials.password);
        this.sessionContainer.startSession(authData.data.token);

        await (this.redirectService.hasRedirectParamInQuery()
            ? this.redirectService.redirectToPagePassedInQuery()
            : this.redirectService.redirectToDefaultPage());
    }
}
